export default __webpack_public_path__ + "static/logo-58761d2ad63883d7b3cc7d9da0ea7e38.png";